import React, { useEffect, useState } from 'react';
import Lottie from 'react-lottie';
import * as Routes from '../../../scripts/routes';
import animationData from '../../lotties/finish-process-document.json';
import ProcessoService from '../../services/ProcessoService';
import Sleep from '../../utils/Sleep';
import CardBaseProcessamentoSo from './CardBaseProcessamentoSo';
import ProcessoSoLogWatch from './ProcessoSoLogWatch';

const index = ({numero_processo, track, user_id}) => {
  const numero_ano                                          = numero_processo.replace('/', '_');
  const userId                                              = user_id;
  const [loading, setLoading]                               = useState(true);
  const [error, setError]                                   = useState(false);
  const [finish, setFinish]                                 = useState(false);
  const [processamentoExistente, setProcessamentoExistente] = useState(false);

  // INIT SERVICE JOB BY TYPE NEW OR UPDATE
  useEffect(() => {
    (async () => {
      await Sleep(500);
      try {
        let response = null;
        switch (track.type) {
          case 'new_folder_processo_so':
            response = await ProcessoService.processar_new_folder_so_processo(numero_ano);
            break;
          case 'update_folder_processo_so':
            response = await ProcessoService.processar_update_folder_so_processo(numero_ano);
            break;
          case 'em_processamento':
            setProcessamentoExistente(true);
            break;
          default:
            console.log(`undefined track type ${track.type}.`);
        }

        if (response.status == 200) {
          setLoading(false);
        } else {
          throw(response.data.message);
        }
      } catch (e) {
        setError(e.message);
      }
    })();
    return () => {};
  }, [numero_ano]);

  const CardBodyProcessamentoSo = () => {
    if (processamentoExistente) {
      return (
        <>
          <div className='card-body text-center'>
            <div className='fa-8x text-warning animate__animated animate__zoomIn animate__infinite animate__slow'>
              <i className='fas fa-stopwatch' />
            </div>
            <h6 className='text-muted'>
              Atenção, este processo já se encontra em processamento no servidor,
              aguarde um pouco até a finalização do processamento.
            </h6>
          </div>
        </>
      );
    }
    if (finish) {
      return (
        <>
          <div className='card-body text-center'>
            <Lottie
              options={{
                loop:          false,
                autoplay:      true,
                animationData: animationData
              }}
              height={300}
              width={350}
            />
          </div>
        </>
      );
    }
    if (error) {
      return (
        <>
          <div className='card-body text-center'>
            <div className='text-danger'>
              <div className='fa-8x animate__animated animate__zoomIn animate__infinite animate__slow'>
                <i className='fas fa-exclamation-triangle' />
              </div>
              <div dangerouslySetInnerHTML={{ __html: error }} />
              <div>
                Caso deseje ver os arquivos individualmente,
              </div>
              <a className='text-warning' href={Routes.visualizar_folder_processo_path(numero_ano)}>clique aqui</a>
            </div>
          </div>
        </>
      );
    }
    if (loading) {
      return (
        <>
          <div className='card-body text-center'>
            <div className='fa-10x text-primary'>
              <i className='fas fa-cog fa-spin' />
            </div>
          </div>
        </>
      );
    }
    return (
      <ProcessoSoLogWatch track={track}
                          userId={userId}
                          processoAno={numero_ano}
                          showError={error => setError(error)}
                          setProcessamentoExistente={bool => setProcessamentoExistente(bool)}
                          showFinish={() => setFinish(true)} />
    );
  };

  return (
    <>
      <CardBaseProcessamentoSo numeroProcesso={numero_processo} tag={track.type} finished={finish}>
        <CardBodyProcessamentoSo />
      </CardBaseProcessamentoSo>
    </>
  );
};

export default index;
